<template>
  <div class="post-content">
    <div class="row row--flex">
      <div class="col-70">
        <p>Kluczowym elementem podczas decyzji o druku jest wybór papieru, czy też ujmując szerzej – podłoża. Wybór zrównoważony i świadomy wcale nie musi oznaczać papieru zrobionego z recyklingu, szarego, brązowego, trudnego do zadruku lub utrudniającego czytelność. Te papiery mogą być bardzo atrakcyjne i zwracające uwagę na to, że używamy papieru „ekologicznego”, ale są pewnego rodzaju ciekawostką, zazwyczaj wyraźnie droższą. Moim celem jest pokazanie możliwości świadomego wyboru papieru, przy założeniu, że będzie to papier biały, nadający się zarówno do druków akcydensowych (wizytówki, zaproszenia), jak i druku wolumenowego (ulotki, katalogi).</p>
      </div>
      <Sidenote class="col-30">
        <p>Moim celem jest pokazanie możliwości świadomego wyboru papieru, przy założeniu, że będzie to papier biały, nadający się zarówno do druków akcydensowych (wizytówki, zaproszenia), jak i druku wolumenowego (ulotki, katalogi).</p>
      </Sidenote>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Wybór papieru z recyklingu nie jest najbardziej zrównoważonym wyborem, który możemy podjąć. Papier może być poddany recyklingowi do 6 razy, a użycie papieru z kolejnej fazy (z reguły drugiej) nie jest jednoznacznie lepsze niż korzystanie z papieru w jego pierwszej, białej, świeżej inkarnacji. Ważne jest to, jak jakościowy jest produkt pierwotny oraz to, czy my w naszym procesie produkcyjnym nie odetniemy mu drogi w obiegu recyklingowym.</p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p style="margin-bottom: 25px;">W przypadku papierów białych, wybór jest prosty:</p>
        <ul>
          <li>wybieraj papiery niepowlekane</li>
          <li>wybieraj papiery certyfikowane</li>
          <li>wybieraj papiery z możliwie niewielkim śladem węglowym</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Wybieraj papiery niepowlekane</p>
        <p>Papier niepowlekany jest z założenia mniej szkodliwy dla środowiska. Popularna i tania „kreda” to podłoże, którego rdzeń wykonany jest z celulozy i który następnie powlekany jest wustronnie węglanem wapnia z domieszkami wybielającymi itd. Papiery kredowe, szczególnie no name mogą mieć w sobie szkodliwe dla zdrowia domieszki, a nawet mikroplastik. Odzyskanie pulpy papierowej z papieru kredowego w procesie recyklingu jest utrudnione. W zestawieniu papierów znajdziesz także jakościowe papiery powlekane, które mogą być alternatywą dla kredy, jeśli zależy Ci na wydruku na papierze powlekanym.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Wybieraj papiery certyfikowane</p>
        <p>Certyfikaty papieru pozwalają na obiektywną ocenę jego pochodzenia. Mnogość certyfikatów oraz własne certyfikaty i kryteria oceny wprowadzane przez dystrybutorów papieru mogą wprowadzić nieco zamieszania. Ja dla uproszczenia i możliwości porównania papierów sprawdzałam dostępne certyfikaty dotyczące pozyskania materiału (FSC) oraz dotyczące chlorowania papieru (tutaj ideałem jest TFC – total chlorine free). Brałam pod uwagę także inne certyfikaty, m.in. EU Eco Label.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Certyfikaty:</p>
        <p class="certificate">FSC</p>
        <p>Forest Stewardship Council (w skrócie FSC) to międzynarodowa organizacja non-profit, założona przez stowarzyszenia ekologiczne, podmioty komercyjne i związki zawodowe w celu zapewnienia zrównoważonego leśnictwa dzięki jednolitym światowym standardom. Certyfikacja FSC jest bardzo restrykcyjna. Zdecydowałam się na branie pod uwagę tego certyfikatu, a nie alternatywnego, choć zbliżonego PEFC (Programme for the Endorsement of Forest Certification) właśnie z tego względu. Oba systemy są zaangażowane w zrównoważone zarządzanie i mają wiele wspólnych elementów. Niektóre kryteria są wspólne, np.:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <ul>
          <li>planowanie operacyjne odpowiednie do wielkości lasu,</li>
          <li>zrównoważony poziom zarządzania,</li>
          <li>ochrona różnorodności biologicznej i szczególne uwzględnienie obszarów chronionych,</li>
          <li>dostarczanie różnorodnych i wysokiej jakości produktów w rozumieniu optymalizacji wykorzystania naturalnych surowców,</li>
          <li>wybór naturalnie występujących lokalnie gatunków drzew.</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Różnica pomiędzy certyfikatami dotyczy szczegółów. W FSC o kryteriach certyfikacji decydują trzy izby: przedstawiciele stowarzyszeń ochrony przyrody, grupy interesów społecznych i gospodarczych. Z kolei PEFC, jak sama deklaruje, przywiązuje dużą wagę do ochrony interesów właścicieli lasów. Standard FSC jest znacznie bardziej szczegółowy, szczególnie w odniesieniudo indywidualnych kryteriów ekologicznych. Na przykład FSC stanowi, że 5% powierzchni lasu nie powinno być uprawiane, by mogło stanowićobszar referencyjny, a dziesięć drzew na hektar powinno być chronionych jako drzewa siedliskowe w perspektywie długoterminowej. Stosowanie chemicznych pestycydów w lasach z certyfikatem FSC jest dozwolone tylko na podstawie oficjalnego zamówienia, podczas gdy w lasach z certyfikatem PEFC jest ograniczone do „niezbędnej ilości”. Takich drobnych różnic jest więcej; dotyczą one całego planowania lasu, jak chociażby szerokości i rozmieszczenia ścieżek, którymi maszyny mogą się poruszać.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>PEFC przywiązuje dużą wagę do prostych i niedrogich procedur certyfikacyjnych. Podczas gdy w FSC każda firma leśna (tj. także każdy właściciel lasu lub grupa właścicieli) jest sprawdzana raz w roku, PEFC – szczególnie w ramach regionalnej procedury certyfikacji – ma możliwość jednrazowej certyfikacji dużych obszarów, a tym samym znacznie upraszcza proces certyfikacji dla indywidualnego właściciela . PEFC wymaga rocznej kontroli co najmniej 10% powierzchni certyfikowanego lasu. Ten mniejszy wysiłek prowadzi również do niższych kosztów. Innymi słowy – chcąc jasno wskazać bezpieczny certyfikat, wybrałam „klasyka” czyli bardziej restrykcyjny FSC.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p style="margin-bottom: 25px;">Istnieją 3 rodzaje certyfikatów FSC:</p>
        <ul>
          <li>Etykieta „FSC 100%” oznacza, że drewno, z którego wykonano produkt, pochodzi wyłącznie z lasów certyfikowanych w systemie FSC. Organizacja podaje, że jedna trzecia wszystkich roduktów z certyfikatem FSC to produkty z etykietą FSC 100%</li>
          <li>Etykieta „FSC Mix” oznacza, że drewno wykorzystane do stworzenia produktu pochodzi z materiałów z certyfikatem FSC, z recyklingu, albo z drewna kontrolowanego.</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Nie jest to pełna certyfikacja w systemie FSC. Drewno kontrolowane FSC nie jest certyfikowane, ale nie może być pozyskiwane w sposób niezgodny z prawem, z naruszeniem praw zwyczajowych i obywatelskich, w lasach, których szczególne walory przyrodnicze są zagrożone, w lasach przekształcanych w plantacje oraz w lasach, gdzie uprawiane są drzewa modyfikowane genetycznie.</p>
        <ul style="margin: 25px 0;">
          <li>Etykieta „FSC Recycled” oznacza, że całość drewna lub papieru, z którego wykonano produkt pochodzi z materiałów odzyskanych</li>
        </ul>
        <a
          class="source-link source-link--right"
          href="https://pl.fsc.org/pl"
          target="_blank"
          rel="noopener noreferrer"
        >źródło: pl.fsc.org</a>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>
          Warto wiedzieć, że w niektórych drukarnia możemy zamówić papier z certyfikatem FSC lub bez niego. To oznacza, że na nasze życzenie drukarnia może wystąpić o konkretny certyfikat i przyznanie unikalnego numeru certyfikatu. Taka procedura jest związana z dodatkowym nakładem pracy oraz kosztami zewnętrznymi. Papier, który otrzyma na nasze życzenie unikalny certyfikat na życzenie może zatem być droższy. Nie oznacza to jednak, że certyfikat da się „kupić” jeśli produkt nie spełnia wymagań. Listę przydzielonych certyfikatów możesz znaleźć na stronie FSC.
          <span
            class="text-background"
          >Pamiętaj, by przed umieszczeniem logotypu FSC na materiałach, upewnić się, czy masz do tego prawo – ustal to z papiernią lub poproś o wsparcie drukarnię.</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="certificate">ECF/TCF/PCF – jaki wpływ ma na nas chlor?</p>
        <p>Papier produkowany jest z roztworu wodnego celulozy z dodatkami. Musiał być on bielony, by papier nie żółkł (jeśli pamiętasz papier w tanich, wysokonakładowych książkach z lat 80-tych, to właśnie o takie żółknięcie chodzi). Do lat 90-tych powszechnie używanym wybielaczem był chlor.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Wybielanie chlorem elementarnym, tzn. w związkach (EC) sprawia, że zawarta w pulpie lignina jest rozpuszczalna w wodzie. Chlor następnie oddziela się przez ługowanie. Poddany procesowi obróbki chlor z łatwością tworzy związki organiczne i dioksyny. Są one wprowadzane do ekosystemu wraz ze ściekami z przemysłu papierniczego. Co to oznacza dla człowieka? Związki organiczne są szybko wchłaniane przez żywe organizmy i gromadzą się w tkance tłuszczowej, prowadząc do nie uszkodzeń narządów takich jak wątroba i nerki. W latach 80-tych opracowano bezchlorowy proces bielenia, oznaczany jako TCF (total chlorine free). Pieczęć TCF wskazuje papier i pulpę bielone całkowicie bez chloru. To najbardziej najbezpieczniejsze rozwiązanie. Innym jest mniej restrykcyjne ECF (elemental chlorine free), czyli produkcja bez wykorzystania przyswajalnego chloru elementarnego.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Technologia ECF redukuje tworzenie połączeń szkodliwych dla środowiska o 60–80%. W przypadku TCF zagrożenie spada poniżej granicy wykrywalności. Owszem, papiery TCF nie są tak białe jak ECF, co nie oznacza, że wyglądają jak papier makulaturowy. Proces ECF jest tak szeroko rozpowszechniony w Europie, że sięgając po papier możemy zakładać, że trzymamy w rękach nieoznaczony produkt ECF – niemniej, zawsze warto się upewnić. Udział papierów z procesami bielenia TCF na rynku wynosi natomiast około 5%.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Oznaczenia:</p>
        <p>
          <span class="certificate--indend">
            TCF
            <span>(total chlorine free)</span>
          </span>
          podczas bielenia pulpy nie używa się chloru gazowego ani związków chloru takich jak dwutlenek chloru lub podchloryn; zamiast tego używane są związki tlenu, takie jak ozon i nadtlenek wodoru
          <span
            class="certificate--indend"
          >
            ECF
            <span>(elementar chlorine free)</span>
          </span>
          zabrania stosowania chloru gazowego. Stosowane są jednak związki chloru.
          <span
            class="certificate--indend"
          >
            PCF
            <span>(process chlorine free)</span>
          </span>
          jest stosowany w papierach z recyklingu. Ponieważ makulatury nie uznaje się za surowiec, bez względu na to, czy papier wyjściowy zawierał chlor czy nie – ta nazwa oznacza jedynie, że materiał nie został poddany ponownemu bieleniu.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="certificate">EU ECOLABEL</p>
        <p>EU Ecolabel to certyfikat przyznawany przez Komisję Europejską produktom i usługom spełniającym wysokie standardy środowiskowe w całym cyklu życia: od wydobycia surowców, przez produkcję, dystrybucję po zarządzanie odpadami. Oznakowanie ekologiczne UE promuje gospodarkę o obiegu zamkniętym, zachęcając firmy do wytwarzania mniejszej ilości odpadów i CO2 w procesie produkcyjnym. Kryteria oznakowania ekologicznego UE zachęcają również przedsiębiorców do opracowywania produktów trwałych, łatwych do naprawy i recyklingu.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Produkty z papieru graficznego EU Ecolabel spełniają kryteria, które gwarantują:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <ul>
          <li>Niskie zanieczyszczenie powietrza i wody w procesie produkcji</li>
          <li>Ograniczenie użycia substancji niebezpiecznych</li>
          <li>Wykorzystanie certyfikowanych włókien z lasu zarządzanego w sposób zrównoważony</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>Ważność certyfikacji EU Ecolabel możesz sprawdzić online.</p>
        <a
          href="http://ec.europa.eu/ecat/category/en/54/graphic-paper"
          target="_blank"
          rel="noopener noreferrer"
          class="source-link"
        >ec.europa.eu/ecat/category/en/54/graphic-paper</a>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="certificate">NORDIC ECOLABEL</p>
        <p>Nordic Ecolabel (zwany też nordyckim łabędziem) to oficjalnie zarejestrowane oznakowanie ekologiczne dla produktów pochodzących z krajów skandynawskich. Kryteria certyfikatu obejmują cały cykl życia produktu – od jego wytworzenia (sprawdzane jest stosowanie chemikaliów, zanieczyszczenie powietrza i wody), po dystrybucję i możliwość utylizacji. W Unii Europejskiej Nordic Ecolabel odpowiada EU Ecolabel. Oba systemy mają podobne kryteria kontroli i często działają synchronicznie.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="certificate">Der Blaue Engel / Blue Angel</p>
        <p>Niemiecki certyfikat przyznawany od lat 70-tych. Papier z tym certyfikatem przynajmniej w 80% musi pochodzi z recyklingu. Jeśli podczas produkcji papieru została użyta celuloza, musi ona pochodzić z lasów zarządzanych w sposób zrównoważony i przedsiębiorstw leśnych o wysokich standardach ekologicznych.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>więcej o kryteriach oraz lista certyfikowanych papierów:</p>
        <a
          href="https://www.blauer-engel.de/en/products/paper-printing/printing-and-publication-papers"
          target="_blank"
          rel="noopener noreferrer"
          class="source-link"
        >blauer-engel.de/en/products/paper-printing/printing-and-publication-papers</a>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="certificate">EMAS</p>
        <p>EMAS to europejska certyfikacja, wspierająca zrównoważony rozwój oraz efektywne zarządzanie dostępnymi zasobami i energią. Organizacje objęte EMAS mają obowiązki w zakresie ochrony środowiska, optymalizują ponoszone koszty i efektywnie zarządzają energią i zasobami.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p>więcej informacji:</p>
        <a
          href="http://emas.gdos.gov.pl/o-emas"
          target="_blank"
          rel="noopener noreferrer"
          class="source-link"
        >emas.gdos.gov.pl/o-emas</a>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Wybieraj papiery z możliwie niewielkim śladem węglowym</p>
        <p>Uważaj na greenwashing. Producenci papieru wprowadzają wiele atrakcyjnych podłoży z domieszkami, mającymi nam zasugerować proekologiczne nastawienie. Zwróć uwagę na to, czy te rozwiązania są biodegradowalne (jeśli nie, to nie będą mogły uczestniczyć w procesie recyklingu). Egzotyczne domieszki w papierze czy papier dostępny i sprowadzany na życzenie mogą być ekologiczną pułapką. W miarę możliwości wybieraj papiery dostępne lokalnie, nie szukaj pozornych „ekologicznych” rozwiązań.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-70">
        <p class="heading--sans-serif">Najprostsze wybory</p>
        <p>Na rynku dostępne są dziesiątki podłoży – od białych przez barwione w masie po niestandardowe. Dla uproszczenia przygotowałam listy podłoży, na który drukować warto, a na których nie.</p>
        <p style="font-weight: 400; margin: 15px 0;">Najlepszy wybór wśród papierów białych:</p>
        <p
          style="font-weight: 400; margin-bottom: 15px;"
        >Papiery, które są TCF (total chlorine free), bardzo bezpieczne oraz bez wybielaczy optycznych:</p>
        <ul>
          <li>Antalis: Nautilus (poza wersją superwhite) z papierni Mondi – FSC recycled, TCF, dodatkowo certyfikat Blue Angel.</li>
          <li>
            Antalis i Igepa: Bio Top 3 z papierni Mondi – FSC, TCF, EU
            Ecolabel, ISO 9706, Austrian Eco-Label
          </li>
          <li>
            Panta: Alto Naturel i Alto Creme w spulchnieniu 1,3 oraz 1,5 –
            FSC, TCF, EMAS, ISO 9706 oraz Nordic Swan Ecolabel.
          </li>
        </ul>
        <p
          style="margin: 50px 0 25px;"
        >Papiery, które mają certyfikat EU Ecolabel lub odpowiedni Nordic Ecolabel:</p>
        <ul>
          <li>Wszystkie papiery Munken Design firmy Arctic Paper (także w dystrybucji Europapieru) – EU Ecolabel, Nordic Ecolabel, FSC, ECF, certyfikat do kontatu z jedzeniem, EMAS, certyfikat bezpieczeństwa zabawek DIN EN 71-3 oraz certyfikat papieru archiwalnego ISO 9706.</li>
          <li>Antalis: Nautilus Superwhite z papierni Mondi – EU Ecolabel, FSC recykled, ECF, dodatkowo OHSAS oraz certyfikat papieru archiwalnego DIN 6738.</li>
          <li>Antalis i Igepa: DNS Premium z papierni Mondi – Eu Ecolabel, FSC, ECF.</li>
          <li>Antalis: Print Speed Offset / Laser Jet – EU Ecolabel, FSC, ECF, certyfikat papieru archiwalnego ISO 9706.</li>
          <li>Igepa: MaxiScript z papierni UPM – EU Ecolabel, FSC, ECF, certyfikat bezpieczeństwa zabawek EN 71-3, certyfikat papieru archiwalnego ISO 9706, certyfikat do kontatu z jedzeniem, EMAS.</li>
          <li>Igepa: Soporset Premium Pre-Print z papierni The Navigator Company – EU Ecolabel, FSC, ECF.</li>
          <li>Europapier: IQ Selection Smooth od Mondi – EU Ecolabel, FSC, ECF, certyfikat papieru archiwalnego ISO 9706.</li>
          <li>Europapier: Pergraphica od Mondi – EU Ecolabel, FSC, ECF – tu warto zaznaczyć, że zawiera włókna eukaliptusa, nie pozyskiwanego – jak wiadomo – lokalnie.</li>
          <li>Zing – cały wybór papierów niepowlekanych, drzewnych od Stora: Brite Book, Bulk, Classic, Creamy, Novel 76/80, Plus Book – interesujący, ekonomiczny wybór dla większych objętościowo publikacji książkowych.</li>
        </ul>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p class="heading--sans-serif">Najgorsze wybory</p>
        <p>
          <span
            class="text-background"
          >Wybór, którego zasadność warto przemyśleć to podłoża syntetyczne, papier kredowy i multiloft.</span> Wszystkie one posiadają domieszki, mające wpływ na możliwość poddania ich recyklingowi. W przypadku podłoży syntetycznych sprawa jest prosta – nie uczestniczą one w cyklu recyklingowym papieru. Przy papierze kredowym sytuacja się komplikuje. Papier ten tylko w niewielkim stopniu składa się z naturalnych składników, zawiera dużo kleju i pigmentu. Nie jest najbardziej pożądanym wyborem. Przy papierze typu multiloft, czyli kilkuwarstwowym papierze-kanapce z kolorowym (lub białym) rdzeniem, mamy do czynienia ze zintegrowanym klejem na membranie. Ze względu na wieloelementowość, nie jest więc polecanym podłożem.
        </p>
      </div>
      <div class="col-30">
        <RelatedPosts :currentPostID="postID" />
      </div>
    </div>
    <ScrollToTop />
  </div>
</template>

<script>
import RelatedPosts from "../RelatedPosts";
import ScrollToTop from "../ScrollToTop";
import Sidenote from "../Sidenote";

export default {
  name: "Post3",
  components: {
    RelatedPosts,
    ScrollToTop,
    Sidenote
  },
  props: {
    postID: Number
  }
};
</script>

<style lang="scss">
</style>